module.exports = __webpack_public_path__ + "static/media/help-support-banner-mtn.9fe9fc26.png";